import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import { StyledEngineProvider } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import {
  ActionsProvider,
  ApiProvider,
  BugsnagProvider,
  DomainProvider,
  GAProvider,
  I18nProvider,
  IntercomProvider,
  ModalsProvider,
  PlaidProvider,
  PromptProvider,
  QueryProvider,
  SSOProvider,
  StoreProvider,
  UserpilotProvider
} from "./components";
import { Root } from "./Routers/Root";
import { getDomain } from "./utils/auth";
import { logBuildInfo } from "./utils/build-info";

import "./styles/main.scss";

dayjs.extend(utc);

export const Index = (): JSX.Element => {
  const domain = getDomain();
  return (
    <BugsnagProvider>
      <StoreProvider>
        <I18nProvider>
          <StyledEngineProvider injectFirst>
            <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
              <Router>
                <ApiProvider>
                  <PlaidProvider>
                    <QueryProvider>
                      <ActionsProvider>
                        <DomainProvider domain={domain}>
                          <GAProvider>
                            <UserpilotProvider>
                              <IntercomProvider>
                                <PromptProvider>
                                  <ModalsProvider>
                                    <SSOProvider>
                                      <Root />
                                    </SSOProvider>
                                  </ModalsProvider>
                                </PromptProvider>
                              </IntercomProvider>
                            </UserpilotProvider>
                          </GAProvider>
                        </DomainProvider>
                      </ActionsProvider>
                    </QueryProvider>
                  </PlaidProvider>
                </ApiProvider>
              </Router>
            </LocalizationProvider>
          </StyledEngineProvider>
        </I18nProvider>
      </StoreProvider>
    </BugsnagProvider>
  );
};

// Log build information to console
logBuildInfo();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<Index />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
